import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

export default {
  ...createBasicSelectors('changeLog'),
}
